var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0625 0.3125C17.9687 0.125 17.7812 0 17.5937 0C17.4375 0 17.2812 0.09375 17.1562 0.28125C16.1875 1.96875 14.4687 3 12.5 3H10C6.6875 3 4 5.6875 4 9C4 9.65625 4.09375 10.2812 4.28125 10.875C1.90625 12.9062 1.03125 15.3125 0.999997 15.3438C0.937497 15.5938 1.0625 15.9062 1.3125 16C1.5625 16.0625 1.875 15.9375 1.96875 15.6875C1.96875 15.6562 2.71875 13.6562 4.6875 11.8438C5.71875 13.7188 7.6875 15 10 15C10.1875 15 10.4062 15 10.625 14.9688C15.5312 14.625 19 10.2188 19 4.84375C19 3.28125 18.6562 1.65625 18.0625 0.3125ZM10.5312 14C10.3437 14 10.1562 14 10 14C8 14 6.3125 12.8438 5.5 11.1875C7.125 9.96875 9.375 9 12.5 9C12.75 9 13 8.78125 13 8.5C13 8.25 12.75 8 12.5 8C9.28125 8 6.90625 8.96875 5.15625 10.2188C5.0625 9.8125 5 9.4375 5 9C5 6.25 7.21875 4 10 4H12.5C14.4687 4 16.2812 3.125 17.4687 1.59375C17.8125 2.625 18 3.75 18 4.84375C18 9.8125 14.8437 13.6562 10.5312 14Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.cbe1a02f97b4cb51bb1bc2d37d2bda8d.svg";
export { ForwardRef as ReactComponent };